import { useState, useEffect } from 'react'
import { DatePattern} from "../date/DatePattern";
import {Periodicity} from "../date/PeriodicityPattern";
import {weekDaysIndexed, monthsIndexed, dayDescriptors, frequencyTypes, initDatePatternState} from "../../util";

export const RecurringExpirationType = ({ pointType, pointExpiration }) => {

  const fieldPrefix = `point_expirations[${pointType.id}]`,
    frequencyTypes = { 'yearly': 'Year', 'monthly': 'Month', 'weekly': 'Week' };

  const [ periodicity, setPeriodicity ] = useState({
    period: pointExpiration.period ?? Object.keys(frequencyTypes).at(0),
    frequency: pointExpiration.frequency ?? 1
  })

  const [datePattern, setDatePattern] = initDatePatternState(pointExpiration)

  return (
    <div className="recurring-field-group">

      <Periodicity
        state={[periodicity, setPeriodicity]}
        {...{frequencyTypes}}
        {...{fieldPrefix}}
      ></Periodicity>

      <DatePattern
        state={[datePattern, setDatePattern]}
        {...{periodicity}}
        {...{fieldPrefix}}
      ></DatePattern>

      <div className="tf-description">
        { pointType.label } will expire every {periodicity.frequency} { frequencyTypes[periodicity.period].toLowerCase() }{ periodicity.frequency > 1 && 's' } on
        { datePattern.dayDescriptor === 'dayofmonth'
          ? ` day ${datePattern.dayOfMonth}`
          : ` the ${ datePattern.dayDescriptor } ${ weekDaysIndexed[datePattern.dayOfWeek] }`
        }
        { periodicity.period === 'yearly' ? ` of ${ monthsIndexed[datePattern.month] }` : ' of the period' }
      </div>
    </div>
  )
}
